<script setup>
import { ref } from "vue";
import ContentFilters from 'shared/components/contentLibrary/contentFilters.vue';
import useContentLibrary from 'shared/components/contentLibrary/composables/useContentLibrary';

const contentLibrary = ref(useContentLibrary());
</script>

<template>
	<content-filters
		v-if="contentLibrary.filtersAreVisible"
		:clear-filters-label="
			contentLibrary.clearAllFiltersLabel
		"
	/>
</template>
